import { set, map, omit, concat, findIndex } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST, SET_LINES, SET_SELECTED, SET_PROPERTY, REMOVE_LINE, REMOVE_LIST_ITEM } from 'vx/mutations'

// User state.
const state = {
  list: [],
  lines: [],
  selected: null,
  filter: {search: null}
}

// User state getters.
const getters = {

  /**
   * User state as a decorated object.
   */
  list: list => state.list,

  getStandardHours: state => {
    return _.sumBy(state.lines.filter(line => line.include && line.rate == "Standard"), 'sum')
  },

  getUrgentHours: state => {
    return _.sumBy(state.lines.filter(line => line.include && line.rate == "Urgent"), 'sum')
  },

  getLineByIndex: state => (index) => {
    return state.lines[index]
  }
}

// User actions.
const actions = {

  /**
   * clear the selected client
   * @param {*} payload 
   */
  clearSelected({commit}, payload) {
    commit(SET_LINES, [])
    commit(SET_SELECTED, null)
  },

  /**
   * Get a list of quotes.
   */
  async getList ({ commit }, payload) {

    commit(SET_LIST, [])
    commit(SET_LINES, [])
    commit(SET_SELECTED, null)

    const response = await http.get(`uninvoiced?${queryString(state.filter)}`)

    commit(SET_LIST, response.data)

    return response
  },

  async getLines ({ commit, dispatch }, id) {
          
    const response = await http.get(`uninvoiced/${id}?${queryString(state.filter)}`)

    if (response.data.length) {
      commit(SET_LINES, response.data)
      commit(SET_SELECTED, id)
    } else {
      //All lines have been billed so remove the client
      commit(REMOVE_LIST_ITEM, state.selected)
      dispatch('clearSelected')
    }

    return response
  },

  async createInvoice ({ commit, dispatch }, payload) {
          
    const response = await http.post(`/uninvoiced/createInvoice/`, {client_id: state.selected, lines: state.lines})

    dispatch('getLines', state.selected)

    return response
  },

  /**
   * Don't include this line when we creat an invoice for this client
   * @param {*} index 
   */
  includeLine({commit}, payload) {
    commit(SET_PROPERTY, {property: 'include', value: payload.value, index: payload.index})
  },

  async setNotBillable({commit, dispatch}, index) {

    let line = state.lines[index]

    const response = await http.post(`uninvoiced/notbillable`, {type: line.type, id: line.eid})

    commit(REMOVE_LINE, index)

    if (state.lines.length == 0) {
      commit(REMOVE_LIST_ITEM, state.selected)
      dispatch('clearSelected')
    }
  }
}

// User state mutations.
const mutations = {
  
  /**
  * Set the users state.
  */
  [SET_LIST] (state, list) {
    state.list = list
  },

  /**
  * Set the invoice lines.
  */
    [SET_LINES] (state, lines) {
    state.lines = lines
  },

  [SET_SELECTED] (state, selected) {
    state.selected = selected
  },

  [SET_PROPERTY] (state, {property, value, index} ) {
    set(state.lines[index], property, value)
  },

  [REMOVE_LINE] (state, index) {
    state.lines.splice(index, 1);
  },

  [REMOVE_LIST_ITEM] (state, clientId) {
   
    let index = findIndex(state.list, client => client.client.id === clientId)
    state.list.splice(index, 1)
  }

}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
